import {useCurrentPageType} from '@aboutyou/router';
import {useIsConsentBannerClosed} from '@aboutyou/storage';
import {useFullSession} from '@aboutyou/user';
import React from 'react';
import {useCrmCouponTokenParam} from '../Coupons/useCrmCouponTokenParam';
import {
  UnlockCouponInfo as UnlockCouponInfoFetcher,
  UnlockCouponInfoProps,
} from './UnlockCouponInfo.eager';

export const UnlockCouponInfo: React.FC<UnlockCouponInfoProps> = props => {
  const fullSession = useFullSession();
  const isConsentBannerClosed = useIsConsentBannerClosed();
  const couponToken = useCrmCouponTokenParam();
  const pageType = useCurrentPageType();

  /**
   * Do not show the UnlockCoupon animation on mobile stack if the consent banner is not acted upon
   */
  if (process.env.STACK === 'mobile' && !isConsentBannerClosed) {
    return null;
  }

  if (!fullSession || !couponToken) {
    return null;
  }

  if (
    pageType !== 'articleDetail' &&
    pageType !== 'category' &&
    pageType !== 'couponLandingPage' &&
    pageType !== 'brandShop'
  ) {
    return null;
  }

  return <UnlockCouponInfoFetcher {...props} />;
};
